<template>
    <div @click="back(linkTo)" class="back-link">返回主页</div>
</template>

<script>
export default {
    name: 'Back',
    // inject: ['reload'],
    props: {
        linkTo: String
    },
    methods: {
        back(to) {
            const THAT = this;
            // THAT.reload(); // 刷新当前页面
            THAT.$router.replace(to).catch(err => err);
        }
    },
    computed: {}
};
</script>
<style scoped lang="less">
.back-link {
    position: fixed;
    bottom: 200px;
    left: 0;
    width: 150px;
    padding-right: 15px;
    height: 80px;
    font-size: 28px;
    line-height: 76px;
    text-align: center;
    background: #2945d4;
    color: #fff;
    border-radius: 0 100px 100px 0;
    border: 2px solid #fff;
    border-left: 0;
    z-index: 2;
    cursor: pointer;
}
</style>
